import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { ProductType as IProductType } from '@cemex-core/cmx-api/models/business-lines/product-type';
import {
  AsyncState,
  asyncFailed,
  asyncStart,
  asyncState,
  asyncSuccess,
  createAsyncState,
} from '@ordersnproducts/utils/create-async-state';
import { createReducer, on } from '@ordersnproducts/utils/create-reducer';
import ProductTypeActions from '../actions/product-type.actions';

interface ProductTypeEntityState extends EntityState<IProductType> {
  activeEntityId: number;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ProductTypeState extends AsyncState<ProductTypeEntityState> {}

export const adapterProductType: EntityAdapter<IProductType> = createEntityAdapter<IProductType>({
  selectId: ({ productTypeId }) => `${productTypeId}`,
});

export const initialProductTypeState = createAsyncState({
  ...adapterProductType.getInitialState({
    activeEntityId: null,
  }),
});

export const productTypeReducer = createReducer(
  initialProductTypeState,

  on(ProductTypeActions.fetch, asyncStart()),

  on(ProductTypeActions.fetchFailed, asyncFailed()),

  on(
    ProductTypeActions.fetchSuccess,
    asyncSuccess(({ payload }, state) => ({
      payload: adapterProductType.setAll(payload, state.payload),
    })),
  ),

  on(
    ProductTypeActions.setActive,
    asyncState(({ productTypeId }, state) => ({
      payload: {
        ...state.payload,
        activeEntityId: productTypeId,
      },
    })),
  ),

  on(ProductTypeActions.resetProductTypeState, (state) => ({
    ...initialProductTypeState,
  })),
);

export function reducer(state: ProductTypeState | undefined, action: Action) {
  return productTypeReducer(state, action);
}
